(function () {
  document.querySelectorAll('.dp-faq-list').forEach(function (list) {
    var items = list.querySelectorAll('.dp-faq-item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        }
      });
    });
  });
})();